import {CheckOutModalApp} from "../Functionality/CheckOutModalApp";
import CustomModal from "../../../../../components/Modal/CustomModal";
import {
    CloseIcon,
    IconAvatarTable, IconChipCircleTools,
    IconEntryDevice,
    IconExitDevice,
    ImgCheckOutHeader,
    InfoChip, NumericFieldChip, TrashOutlineIcon,
} from "../../../../../components/buttons/IconButtons";
import CustomCard from "../../../../../components/CustomCard";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {CustomTextField} from "../../../../../components/CustomTextField";
import React from "react";
import CustomAutocompleteSearch from "../../../../../components/CustomAutocompleteSearch";
import CustomDateTimePicker from "../../../../../components/CustomDateTimePicker";
import {CustomCheckbox} from "../../../../../components/CustomCheckbox";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import {DATE_TIME_FORMAT_NAME_MODEL, equipmentListToLabel, getDateFormat} from "../../../../../Apis/functions";
import RowCardList from "../SubComponent/RowCardList";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {SERVICE_EQUIPMENT_CURRENTlY_INSIDE} from "../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 03 de diciembre de 2025
 */

const CheckOutModal = (props) => {
    const { onHide, itemSelected, onSuccess, selectableAccessDate = false } = props

    const {
        showBadgeMessage,
        handleCloseBadge,
        t,
        selectedList,
        item,
        emptyFields,
        handleChange,
        handleCheckboxChange,
        checkedIds,
        newSelected,
        setNewSelected,
        handleSelected,
        handleCheckOut,
        deleteSelected,
        removeSelectedIds,
        resolveExitDate,
        handleAccessDateChange,
        commitAccessDate
    } = CheckOutModalApp({
        itemSelected,
        onHide,
        onSuccess,
        selectableAccessDate
    });

    return (
        <CustomModal
            {...props}
            size='lg'
            display={'m-0px'}
            classNameBody="m-0 p-0"
            onHide={onHide}
            onConfirm={handleCheckOut}
            topLeftHeader={
                <div className={'d-flex align-items-center pt-2'}>
                    <IconExitDevice className={'w-32px h-32px'}/>
                    <p className={'fs-modal-title ibl-font-w-600 font-color-general-950 ml-2 text-uppercase'}>{t("check_out")}</p>
                </div>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <ImgCheckOutHeader className={'w-100'}/>
                <div className={'row my-3'}>
                    <div className={'col-12 d-flex justify-content-between'}>
                        <div className={'d-flex justify-content-start align-items-center'}>
                            <div><IconAvatarTable/></div>
                            <CustomTooltip
                                text={itemSelected?.userFullName}
                                classes={'text-capitalize font-color-general-950 fs-14px ml-2 text-ellipsis'}
                                showIfTruncated={true}
                            />
                        </div>
                        {/* Entry the exit closes. The guard flow carries it as entryDate, so nothing shows there //*/}
                        { itemSelected?.accessDate &&
                            <div className={'d-flex align-items-center gap-2'}>
                                <IconEntryDevice className={'icon-color-shades-500 w-16px h-16px'}/>
                                <p className={'ibl-font-w-400 font-color-shades-500 fs-14px m-0'}>
                                    {t('entry') + ': ' + getDateFormat(
                                        itemSelected.accessDate,
                                        false,
                                        DATE_TIME_FORMAT_NAME_MODEL.shortMonthWithTime12
                                    )}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                <div className={'border-bottom-shades-300'}/>


                <div className={'row my-4'}>
                    { selectableAccessDate &&
                    <div className='col-12'>
                        <CustomDateTimePicker
                            id={'dp_com_date_time'}
                            name={'accessDate'}
                            onChange={(e) => handleAccessDateChange(e)}
                            /* The materials of the entry are asked for the date of the exit, so the date is
                               taken when the guard confirms the selection, closes the picker or leaves the
                               field, and not on every move of it: the field changes on every view and on every
                               keystroke, and each change was a search of its own. A date written by hand never
                               opens the picker, so the blur is the only one it fires //*/
                            onAccept={(e) => commitAccessDate(e)}
                            onClose={() => commitAccessDate()}
                            onBlur={() => commitAccessDate()}
                            trans={'exit'}
                            value={item?.accessDate}
                            required={true}
                            disablePast={false}
                            disableFuture={true}
                            emptyFields={emptyFields}
                        />
                    </div>
                    }

                    <div className='col-12'>
                        {/* The date of the exit travels with the search so the list is what that exit can close:
                            a material that came in on a previous day and never left is in it, and one that had
                            already left by then is not. It goes in attendanceEndDate, the date slot the search
                            body already carries. Empty until the guard picks it, read as this moment //*/}
                        <CustomAutocompleteSearch
                            id="txt_com_search_equipment"
                            label="equipment_material"
                            itemSelected={newSelected}
                            setItemSelected={setNewSelected}
                            handleSelected={handleSelected}
                            listTransform={equipmentListToLabel}
                            api={SERVICE_EQUIPMENT_CURRENTlY_INSIDE}
                            bodyApi={{
                                userId: itemSelected?.contractorId,
                                attendanceEndDate: resolveExitDate()
                            }}
                            /* Closed until the date is there, because it is the date that decides which
                               materials the list can offer. The flows that stamp the exit on the spot always
                               have one, so only the one that lets the guard pick it starts closed */
                            disabled={!resolveExitDate()}
                            reset={true}
                            showSubSection={true}
                            filter={removeSelectedIds}
                        />
                    </div>

                    <div className={'col-12 py-12px'}>
                        { showBadgeMessage &&
                            <CustomUserChip
                                className={'m-0 chip-secondary-150-100 w-100 px-1 py-12px justify-content-start'}
                                name={t('check_out_modal_badge')}
                                Icon={InfoChip}
                                showAvatar={true}
                                classNameBoxText={'pr-5'}
                                classNameIcon="icon-color-secondary-700 w-h-24px"
                                variant='large'
                                iconPosition={POSITION_MODEL.LEFT}
                                onDelete={handleCloseBadge}
                                deleteIcon={<CloseIcon height={16} width={16} className="icon-color-secondary-700"/>}
                            />
                        }
                    </div>

                    <div className={"col-12"}>
                        <CustomCard classContent={"h-180px overflow-y-auto"}>
                            {
                                selectedList.map(item => {
                                    return (
                                        <RowCardList
                                            className={`${checkedIds.includes(item.id) && "border-full-secondary-500"}`}
                                            leftPart={
                                                <>
                                                    <CustomCheckbox
                                                        id={`cb_${item.id}`}
                                                        checked={checkedIds.includes(item.id)}
                                                        onChange={() => handleCheckboxChange(item.id)}
                                                        disabled={!item?.saved}
                                                    />

                                                    <div className={`justify-content-start d-flex gap-2 align-items-center`}>
                                                        <div>
                                                            <IconChipCircleTools/>
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={item?.label}
                                                                classes={`fs-14px ibl-font-w-600 text-ellipsis-1-row`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            centerPart={
                                                <>
                                                    <div><NumericFieldChip className={"icon-color-shades-600"}/></div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={item?.code}
                                                            classes={`fs-14px font-color-shades-600 ibl-font-w-400 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            rightPart={
                                                <>
                                                    { item?.saved ?
                                                        <CustomChip
                                                            background={checkedIds.includes(item.id)  ? colors.secondary100 : colors.shades200}
                                                            fontColor={checkedIds.includes(item.id)  ? colors.secondary700 : colors.shades700}
                                                            borderColor={checkedIds.includes(item.id) ? colors.secondary150 : colors.shades150}
                                                            legend={checkedIds.includes(item.id) ? t("take") : t('leave')}
                                                            variant={'large'}
                                                            />
                                                        :
                                                        <ButtonIcon
                                                            className='btn-transparent'
                                                            id='btn_com_delete'
                                                            Icon={TrashOutlineIcon}
                                                            iconProps={'icon-color-shades-400'}
                                                            onClick={()=> deleteSelected(item.id)}
                                                        />
                                                    }
                                                </>
                                            }
                                        />
                                    )
                                })
                            }
                        </CustomCard>
                    </div>

                    <div className={'col-12 pt-4'}>
                        <p className="text-center ibl-font-w-700 text-uppercase">
                            {t('please_provide_a_brief_reason_related_to_this_check_out')}
                        </p>
                    </div>
                    <div className='col-12 pt-4'>
                        <CustomTextField
                            id="txt_com_note"
                            length={512}
                            name="note"
                            value={item.note}
                            trans="note"
                            type="text"
                            onChange={handleChange}
                            multiline={true}
                        />
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default CheckOutModal;
